import React, { Fragment } from 'react';
import { Row, Col,Table } from 'reactstrap';


const Validity = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            <tr>
                                <th>Validity</th>
                                <td className="text-right pr-5">{data.Select_Validity ? data.Select_Validity + ' days': '-'}</td>
                            </tr>
                            <tr>
                                <th>Product visibility limit</th>
                                <td className="text-right pr-5">{data.Product_Visibility_Allowed_in_Days_Max ?  data.Product_Visibility_Allowed_in_Days_Min  +' day(s) - ' + data.Product_Visibility_Allowed_in_Days_Max + 'day(s)' : '-'}</td>
                            </tr>
                            <tr>
                                <th>Product sale allowed limit</th>
                                <td className="text-right pr-5">{data.Product_Sale_Allowed_in_Days_Max ? data.Product_Sale_Allowed_in_Days_Min +' day(s) - ' +  data.Product_Sale_Allowed_in_Days_Max + 'day(s)' : '-'}</td>
                            </tr>
                            <tr>
                                <th>Cooling period</th>
                                <td className="text-right pr-5">{data.cooling_time_days ? data.cooling_time_days +' day(s)'  : '-'}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Validity;